(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["age-gate"]) return;
  try {
    
  (function () {
    var storageKey = 'beckfords_age_verified';
    var gate = document.getElementById('age-gate');
    if (!gate) return;

    function storageHasVerification(storage) {
      try {
        return storage.getItem(storageKey) === 'true';
      } catch (error) {
        return false;
      }
    }

    function setVerification(storage) {
      try {
        storage.setItem(storageKey, 'true');
      } catch (error) {}
    }

    if (storageHasVerification(localStorage) || storageHasVerification(sessionStorage)) {
      document.documentElement.classList.add('age-gate-verified');
      gate.hidden = true;
      document.body.style.overflow = '';
      return;
    }

    document.body.style.overflow = 'hidden';

    var enterBtn = gate.querySelector('[data-age-gate-enter]');
    var exitBtn = gate.querySelector('[data-age-gate-exit]');
    var rememberBox = gate.querySelector('[data-age-gate-remember]');

    enterBtn.addEventListener('click', function () {
      if (rememberBox && rememberBox.checked) {
        setVerification(localStorage);
      } else {
        setVerification(sessionStorage);
      }
      document.documentElement.classList.add('age-gate-verified');
      gate.hidden = true;
      document.body.style.overflow = '';
    });

    exitBtn.addEventListener('click', function () {
      window.location.href = 'https://www.google.com';
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article"]) return;
  try {
    
  document.querySelectorAll('[data-share-url]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var url = this.getAttribute('data-share-url');
      if (navigator.share) {
        navigator.share({ url: url });
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function() {
          var label = btn.querySelector('.art-share__label');
          if (label) {
            var original = label.textContent;
            label.textContent = '\u2713';
            setTimeout(function() { label.textContent = original; }, 1500);
          }
        });
      }
    });
  });

  var dialog = document.querySelector('[data-lightbox]');
  if (dialog) {
    document.querySelectorAll('[data-lightbox-open]').forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        dialog.showModal();
      });
    });

    dialog.querySelector('[data-lightbox-close]').addEventListener('click', function() {
      dialog.close();
    });

    dialog.addEventListener('click', function(e) {
      if (e.target === dialog || e.target.classList.contains('art-lightbox__inner')) {
        dialog.close();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function() {
    var url = new URL(window.location.href);
    if (!url.searchParams.has('sort_by')) {
      url.searchParams.set('sort_by', 'price-ascending');
      window.location.replace(url.toString());
      return;
    }

    var select = document.querySelector('[data-sort-select]');
    if (!select) return;
    select.addEventListener('change', function() {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', this.value);
      window.location.href = u.toString();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-login"]) return;
  try {
    
  document.querySelectorAll('[data-toggle-recover]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      var card = document.querySelector('.auth-card');
      var recover = document.querySelector('[data-recover]');
      if (!card || !recover) return;
      var isHidden = recover.hidden;
      recover.hidden = !isHidden;
      card.querySelector('form').style.display = isHidden ? 'none' : '';
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var header = document.querySelector('[data-header]');
    var toggle = document.querySelector('[data-menu-toggle]');
    var nav = document.querySelector('[data-mobile-nav]');
    var hamburger = document.querySelector('[data-hamburger]');

    if (toggle && nav && hamburger) {
      toggle.addEventListener('click', function () {
        var isOpen = !nav.hidden;
        nav.hidden = isOpen;
        hamburger.classList.toggle('is-active', !isOpen);
      });
    }

    if (header) {
      var last = 0;
      window.addEventListener('scroll', function () {
        var y = window.scrollY;
        if (Math.abs(y - last) < 5) return;
        last = y;
        header.classList.toggle('header--scrolled', y > 40);
      }, { passive: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  var mainImage = document.querySelector('[data-main-image]');
  var thumbs = document.querySelectorAll('[data-thumb]');

  thumbs.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      thumbs.forEach(function(t) { t.classList.remove('pdp__thumb--active'); });
      this.classList.add('pdp__thumb--active');
      var url = this.getAttribute('data-image-url');
      mainImage.innerHTML = '<img src="' + url + '" class="pdp__img" loading="lazy">';
    });
  });

  var minusBtn = document.querySelector('[data-qty-minus]');
  var plusBtn = document.querySelector('[data-qty-plus]');
  var qtyInput = document.querySelector('.pdp__qty-input');

  if (minusBtn && plusBtn && qtyInput) {
    minusBtn.addEventListener('click', function() {
      var val = parseInt(qtyInput.value) || 1;
      if (val > 1) qtyInput.value = val - 1;
    });
    plusBtn.addEventListener('click', function() {
      var val = parseInt(qtyInput.value) || 1;
      qtyInput.value = val + 1;
    });
  }

  // Star rating picker
  var picker = document.querySelector('[data-star-picker]');
  if (picker) {
    var starBtns = picker.querySelectorAll('[data-star-value]');
    var starInput = picker.querySelector('[data-star-input]');
    var selectedRating = 0;

    starBtns.forEach(function(btn) {
      btn.addEventListener('mouseenter', function() {
        var val = parseInt(this.dataset.starValue);
        starBtns.forEach(function(b) {
          b.classList.toggle('is-hover', parseInt(b.dataset.starValue) <= val);
        });
      });

      btn.addEventListener('mouseleave', function() {
        starBtns.forEach(function(b) { b.classList.remove('is-hover'); });
      });

      btn.addEventListener('click', function() {
        selectedRating = parseInt(this.dataset.starValue);
        starInput.value = selectedRating;
        starBtns.forEach(function(b) {
          b.classList.toggle('is-active', parseInt(b.dataset.starValue) <= selectedRating);
        });
      });
    });
  }

  // Reviews pagination
  (function() {
    var list = document.querySelector('[data-reviews-list]');
    var pager = document.querySelector('[data-reviews-pager]');
    if (!list || !pager) return;

    var perPage = parseInt(list.dataset.perPage) || 5;
    var cards = list.querySelectorAll('[data-review-index]');
    if (cards.length <= perPage) return;

    var totalPages = Math.ceil(cards.length / perPage);
    var currentPage = 0;
    var prevBtn = pager.querySelector('[data-pager-prev]');
    var nextBtn = pager.querySelector('[data-pager-next]');
    var info = pager.querySelector('[data-pager-info]');

    function showPage(page) {
      currentPage = page;
      var start = page * perPage;
      var end = start + perPage;
      cards.forEach(function(card) {
        var idx = parseInt(card.dataset.reviewIndex);
        card.style.display = (idx >= start && idx < end) ? '' : 'none';
      });
      prevBtn.disabled = page === 0;
      nextBtn.disabled = page >= totalPages - 1;
      info.textContent = (page + 1) + ' / ' + totalPages;
    }

    prevBtn.addEventListener('click', function() {
      if (currentPage > 0) showPage(currentPage - 1);
    });

    nextBtn.addEventListener('click', function() {
      if (currentPage < totalPages - 1) showPage(currentPage + 1);
    });

    showPage(0);
  })();

  // Reviews read more/less
  (function() {
    var cards = document.querySelectorAll('.review-card');
    if (!cards.length) return;

    function updateToggle(card) {
      var body = card.querySelector('[data-review-body]');
      var toggle = card.querySelector('[data-review-toggle]');
      if (!body || !toggle || card.classList.contains('is-expanded')) return;
      toggle.hidden = body.scrollHeight <= body.clientHeight + 1;
    }

    cards.forEach(function(card) {
      var toggle = card.querySelector('[data-review-toggle]');
      if (!toggle) return;
      toggle.addEventListener('click', function() {
        var expanded = card.classList.toggle('is-expanded');
        toggle.textContent = expanded ? toggle.dataset.lessLabel : toggle.dataset.moreLabel;
      });
    });

    function refresh() {
      cards.forEach(function(card) {
        if (card.style.display !== 'none') updateToggle(card);
      });
    }

    refresh();
    window.addEventListener('resize', refresh);
    document.querySelectorAll('[data-pager-prev], [data-pager-next]').forEach(function(btn) {
      btn.addEventListener('click', function() { setTimeout(refresh, 0); });
    });
  })();

  document.querySelectorAll('[data-share-url]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var url = this.getAttribute('data-share-url');
      if (navigator.share) {
        navigator.share({ url: url });
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function() {
          var label = btn.querySelector('.pdp__share-label');
          if (label) {
            var original = label.textContent;
            label.textContent = '\u2713';
            setTimeout(function() { label.textContent = original; }, 1500);
          }
        });
      }
    });
  });


  } catch(e) { console.error(e); }
})();
})();
